import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[75vh] md:min-h-[90vh] flex flex-col items-center justify-center bg-forest-900 text-cream-100 px-4 py-10 md:py-20 overflow-hidden" data-id="element-39">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-amber-500/20 via-transparent to-transparent" data-id="element-40"></div>

      <div className="max-w-6xl mx-auto w-full flex flex-col items-center relative z-10" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="space-y-4 md:space-y-8 text-center max-w-3xl" data-id="element-42">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-playfair font-bold leading-tight text-cream-100" data-id="element-43">
            El Botiquín de Cocina: Cura 15 Males Comunes sin Salir de Casa{' '}
            <span className="text-amber-400 italic font-normal" data-id="element-44">
              (y sin Químicos)
            </span>
          </h1>

          <p className="text-lg md:text-xl font-lora text-cream-200/90 leading-relaxed" data-id="element-45">
            Descubre el protocolo de 10 minutos para transformar tus especias en
            medicina potente, incluso si la farmacia está cerrada y el dolor no
            te deja dormir.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative mx-auto w-full max-w-sm md:max-w-md lg:max-w-lg mt-6 md:mt-10" data-id="element-46">
          <div className="absolute inset-0 bg-amber-500/20 blur-3xl rounded-full" data-id="element-47"></div>
          <img src="https://cdn.magicpatterns.com/uploads/261ZuiXCuMM9gW1YsJimLQ/mk-1.png" alt="Farmacia de Despensa eBook Cover" className="relative z-10 w-full h-auto drop-shadow-2xl rounded-sm border border-forest-700/50" data-id="element-48" />
        </motion.div>

        <motion.a href="#pricing" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="mt-6 md:mt-10 inline-block px-8 py-4 bg-amber-500 hover:bg-amber-400 text-forest-900 font-bold text-lg rounded-sm shadow-[0_0_15px_rgba(200,169,110,0.4)] transition-colors duration-300 text-center uppercase tracking-wider border border-amber-300" data-id="element-49">
          ¡Quiero mi botiquín ahora!
        </motion.a>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce text-amber-500/70" data-id="element-50">
        <ChevronDown size={32} data-id="element-51" />
      </motion.div>
    </section>;
}